module.exports = require('./helpers/bundle-url').getBundleURL('9KyVe') + "logo.c51670a8.svg";